import React from 'react';
import Blogpage from '../Blogpage/Blogpage';
import Blogtext from '../Blogtext/Blogtext';

const Blog = () => {
    return (
        <>
           <Blogpage /> 
           <Blogtext />
        </>
    );
};

export default Blog;